<template>
  <div>
    <nav-breadcrumb :menu="[{label: '资金管理'},{label: '收息复核'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <el-tabs v-model="check2">
        <el-tab-pane label="未复核" name="N" />
        <el-tab-pane label="已复核" name="Y" />
      </el-tabs>
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :is-multiple-selection-show="true"
        @handleSelectionChange="handleSelectChange"
      ></data-table>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" title="收息详情" width="80%">
      <interest-confirm-view :collection-id="collectionId"></interest-confirm-view>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  import InterestConfirmView from "./InterestConfirmView";
    export default {
        name: "InterestReviewList",
      components: {InterestConfirmView},
      data() {
        return {
          check2:'N',
          selectedIds:'',
          page: 1,
          pageSize: 20,
          dialogVisible: false,
          collectionId: '',
          listData: {},
          listColumns: [
            {
              name:'序号',
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'rc__contractNo'
            },
            {
              label: '客户姓名',
              field: 'rc__customerName'
            },
            /* {
               label: '渠道商',
               field: 'd__dealerName'
             },*/
            {
              label: '贷款余额',
              field: 'rc__principalBalance',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '开始日期',
              field: 'rcde__frDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
                else
                  return ''
              }
            },
            {
              label: '结束日期',
              field: 'rcde__toDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
                else
                  return ''
              }
            },
            {
              label: '应还款日',
              field: 'rcde__expectedRepayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
                else
                  return ''
              }
            },
            {
              label: '计息天数',
              field: 'rcde__expectedDays'
            },
            {
              label: '利率(%)',
              field: 'rc__interestRate',
              formatter: function (r,c,v) {
                return v+'%'+'('+Status2CN(r.rc__interestType)+')'
              }
            },
            {
              label: '应还本金',
              field: 'rcde__expectedPrincipalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '应还利息',
              field: 'rcde__expectedInterestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '应收罚息',
              field: 'rcde__expectedOverdueFine',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '应收复利',
              field: 'rcde__expectedCompoundInterest',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '应收小计',
              field: 'rcde__expectedRepayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收本金',
              field: 'rcde__appliedPrincipalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收利息',
              field: 'rcde__appliedInterestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收罚息',
              field: 'rcde__appliedOverdueFine',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '实收复利',
              field: 'rcde__appliedCompoundInterest',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '上期余额',
              field: 'rc__exBalanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '本期余额',
              field: 'rc__excessAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '余额处理方式',
              field: 'rc__excessAmountOption',
              formatter: function (r,c,v) {
                if(r.rc__excessAmount>0)
                  return Status2CN(v)
                else
                  return ""
              }
            },
            {
              label: '操作',

              opts: [
                {
                  label: '查看',
                  class: 'el-icon-view',
                  clickHandler: (index, row)=> {
                    this.collectionId = row.rc__collectionId
                    this.dialogVisible = true
                  }
                },
              ]
            }
          ],
          filters: {
            form: {
              rcde__expectedRepayDate:[],
              rc__customerName:'',
              rc__contractNo:'',
            },
            columns: [

              {
                label: '贷款编号',
                component: 'el-input',
                field: 'rc__contractNo',
              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'rc__customerName',
              },
              {
                label: '应还款日',
                component: 'el-date-picker',
                field: 'rcde__expectedRepayDate',
                op:'eq',
                type: 'month',
                valueFormat:'yyyy-MM-01 00:00:00',
                span: 12,

              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },

          actions: [
            {
              label: '确认',
              class: 'el-button--primary',
              clickHandler: () => {
                if(this.selectedIds==''){
                  this.$message.error('请选择一条数据')
                  return false
                }
                this.BatchUpdate()
              },
              conditions: ()=> this.check2 == 'N'
            }
          ]
        }
      },
      computed : {
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              'xlist.search.rc.check2' : this.check2,
              'xlist.search.rc.check2.op' : 'in',
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        }
      },
      mounted() {
        this.getData()
      },
      methods: {
        getData: function () {
          xhr.getRepaymentCollectionList(
            Object.assign({'rc.check1':'Y','rc.check2':this.check2}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.listData = res.data
              }catch(e){

              }
            })

        },
        handleSelectChange: function (val) {
          let   selectedIds = val.map(item=>item.rc__collectionId)

          this.selectedIds = selectedIds.join(',')
        },
        BatchUpdate:function () {
          xhr.RepaymentCollectionConfirmed(
            {collections:this.selectedIds,
              check2:'Y'
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.getData()
                  this.selectedIds = ''
                }else{

                  this.$message.error(res.data.msgs[0].text)
                }

              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/InterestReviewList.vue